<template>
  <StandardLayout>
    <div slot="main" class="mx-12 my-6 d-flex flex-column align-center justify-center">
      <h1 class="outfit-regular" style="font-size: 10vw">404</h1>
      <p style="font-size: 2vw">The page you are looking for does not exist.</p>
      <v-btn @click="go('LandingView')" color="yellow darken-3" class="elevation-0">
        <v-icon left>mdi-home-outline</v-icon> Return Home
      </v-btn>
    </div>
  </StandardLayout>
</template>
<script>
import StandardLayout from '@/layouts/Standard.vue'
export default {

  name: 'LostView',

  components: {
    StandardLayout,
  },
  
}
</script>